import styled from 'styled-components';
import Tooltip from '@paradigm/design-system/src/components/Tooltip';
import { useSpreadFromMidFeatureFlag } from '@paradigm/features/src/feature-flags/context';

export const SpreadFromMarkColumnLabel = () => {
  const isSpreadFromMidFeatureFlagEnabled = useSpreadFromMidFeatureFlag();
  if (!isSpreadFromMidFeatureFlagEnabled) {
    return null;
  }
  return (
    <>
      <br />
      <SecondaryColumnLabel>
        SFM
        <Tooltip
          id="spread-from-mid"
          tooltipContent={
            <>
              Spread From Mark (SFM) <br />= Traded Price - Mark Price
            </>
          }
        />
      </SecondaryColumnLabel>
    </>
  );
};

const SecondaryColumnLabel = styled.div`
  opacity: 0.7;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 2px;
`;
